<app-header [isMobile]="isMobile"></app-header>

<div class="wrapper">
    <div class="top" [ngStyle]="{backgroundImage: 'url('+ ( !isMobile ? data.bg : data.bgMobile ) +')'}">

        <div class="backButton">
            <a  routerLink="/">
                <img src="assets/img/back-button2.png" class="back" alt="">
                <img src="assets/img/back-button2-rollover.png" class="backOver" alt="">
            </a>
        </div>

        <div *ngIf="data.logo && !isMobile" [class]="'logo ' + data.id" >
            <img [src]="data.logo" alt=""> 
        </div>
    
    </div>

    <div class="aboutWrapper">
        <div class="about">
            <div class="left">
                <div class="imgHolder">
                    <img [src]="data.aboutImage" alt="">
                </div>
            </div>
            <div class="right">
                <div class="title">{{data.title}}</div>
    
                <div class="description">{{data.about}}</div>
            </div>
        </div>
    </div>

    <div class="feaured">
        

        <div class="whereToWatchList" >
            <div class="whereToWatchListHolder">

                <div class="titleHolder">
                    <div class="ttl">
                        Where To Watch
                    </div>
                    <div class="title">
                        {{data.title}} Channel is available on the following streaming platforms
                    </div>
                    <!-- <div class="closeBtn">
                        <app-close-button (click)="onWhereToWatchClose()"></app-close-button>
                    </div> -->
    
                </div>
                <div class="listHolder">
                    <div class="listWrapper">
                        <a [href]="item.link" target="_blank" *ngFor="let item of pageData.get(data.path)?.whereToWatch" [ngClass]="{disabled: item.link == ''}">
                            <img [src]="item.logo" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>

        
    </div>

    
    <app-footer [isInverted]="true"></app-footer>
    
</div>